import { classnames } from 'helpers/utils';
import styles from './member-avatar.module.scss';

// Deterministic pastel palette — the same scheme used by the album-view avatar
// group (pages/single-album/.../album-header) and common/user-initials.
const AVATAR_COLORS = [
  { background: '#ebf5fa', text: '#1b9fd8' },
  { background: '#ebf4f3', text: '#1d8c7f' },
  { background: '#fcf4ea', text: '#eb870e' },
  { background: '#faf7e9', text: '#d6b100' },
];

const initialsOf = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');

interface MemberAvatarProps {
  name: string;
  // Diameter in px (default 32).
  size?: number;
  // Draw a white ring around the avatar (for overlapping stacks / dark backgrounds).
  ring?: boolean;
  className?: string;
  title?: string;
}

export const MemberAvatar = ({
  name,
  size = 32,
  ring = false,
  className = '',
  title,
}: MemberAvatarProps) => {
  const color = AVATAR_COLORS[(name?.length ?? 0) % AVATAR_COLORS.length];

  return (
    <span
      className={classnames(styles.avatar, className, {
        [styles.ring]: ring,
      })}
      title={title ?? name}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        backgroundColor: color.background,
        color: color.text,
      }}
    >
      {initialsOf(name)}
    </span>
  );
};
